var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#C6A75E",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 42.6667V21.3334C37.3332 20.6262 37.0522 19.9479 36.5521 19.4478C36.052 18.9477 35.3737 18.6667 34.6665 18.6667H29.3332C28.6259 18.6667 27.9477 18.9477 27.4476 19.4478C26.9475 19.9479 26.6665 20.6262 26.6665 21.3334V42.6667",
    stroke: "#C6A75E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6665 24H21.3332C19.8604 24 18.6665 25.1939 18.6665 26.6667V40C18.6665 41.4728 19.8604 42.6667 21.3332 42.6667H42.6665C44.1393 42.6667 45.3332 41.4728 45.3332 40V26.6667C45.3332 25.1939 44.1393 24 42.6665 24Z",
    stroke: "#C6A75E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon 6.eb89e7e50ff52c24c7948ce71479be4b.svg";
export { ForwardRef as ReactComponent };